import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=08684c0c&scoped=true&lang=pug&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=08684c0c&prod&lang=stylus&scoped=true&"
import style1 from "./menu.vue?vue&type=style&index=1&id=08684c0c&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08684c0c",
  null
  
)

export default component.exports